import moment from "moment";

export const parseAutoFillDate = (date) => {
  return moment(autoFillDate(date), "DD-MM-YYYY").utc()._d;
};

export const autoFillDate = (text) => {
  if (text) {
    if (text.indexOf("/") === -1) {
      if (/^[0-9]{6}$/.test(text)) {
        const year =
          moment().format("YYYY").substring(0, 2) + text.substr(4, 2);
        const month = formatMonth(text.substr(2, 2));
        const day = formatDay(text.substr(0, 2), month, year);
        return day + "-" + month + "-" + year;
      } else if (/^[0-9]{8}$/.test(text)) {
        const year = text.substr(4, 4);
        const month = formatMonth(text.substr(2, 2));
        const day = formatDay(text.substr(0, 2), month, year);
        return day + "-" + month + "-" + year;
      } else {
        return moment().format("DD-MM-YYYY");
      }
    } else {
      if (
        (/^\d{2}\/\d{2}\/\d{4}$/.test(text) ||
          /^\d\/\d\/\d{4}$/.test(text) ||
          /^\d{2}\/\d\/\d{4}$/.test(text) ||
          /^\d\/\d{2}\/\d{4}$/.test(text)) &&
        /^[\d/]+$/.test(text)
      ) {
        const arr = text.split("/");
        const year = arr[2];
        const month =
          arr[1].length === 2 ? formatMonth(arr[1]) : `0${formatMonth(arr[1])}`;
        const day =
          arr[0].length === 2
            ? formatDay(arr[0], month, year)
            : formatDay(
                arr[0].length === 2 ? arr[0] : `0${arr[0]}`,
                month,
                year
              );
        return day + "-" + month + "-" + year;
      } else if (
        (/^\d{2}\/\d{2}\/\d{2}$/.test(text) ||
          /^\d\/\d\/\d{2}$/.test(text) ||
          /^\d{2}\/\d\/\d{2}$/.test(text) ||
          /^\d\/\d{2}\/\d{2}$/.test(text)) &&
        /^[\d/]+$/.test(text)
      ) {
        const arr = text.split("/");
        const year = moment().format("YYYY").substring(0, 2) + arr[2];
        const month =
          arr[1].length === 2 ? formatMonth(arr[1]) : `0${formatMonth(arr[1])}`;
        const day =
          arr[0].length === 2
            ? formatDay(arr[0], month, year)
            : formatDay(
                arr[0].length === 2 ? arr[0] : `0${arr[0]}`,
                month,
                year
              );
        return day + "-" + month + "-" + year;
      } else {
        return moment().format("DD-MM-YYYY");
      }
    }
  } else {
    return null;
  }
};

const formatMonth = (month) => {
  if (month > 12) {
    return 12;
  }
  return month;
};

const formatDay = (day, month, year) => {
  const maxOfDay = moment(month + "-" + year, "MM-YYYY")
    .endOf("month")
    .format("DD");
  if (day > maxOfDay) {
    return maxOfDay;
  }
  return day;
};
